import React from 'react';

const RadioButton = ({
  name,
  value,
  id,
  onChange,
  label,
  className,
  defaultValue,
  onBlur,
  onSelect,
  disabled,
  ...props
}) => {
  if (disabled === undefined) disabled = false;

  let radioLabel = className
  if (className === undefined || className === '') {
    radioLabel = ''
  }
  
  return (
    <div className='radioField'>
      <label className={`${radioLabel} radio-container`} htmlFor={id}>
        {label}
        <input
          name={name}
          id={id}
          type='radio'
          value={id}
          checked={id === value}
          onChange={onChange}
          disabled={disabled}
          onClick={(e) => {
            onSelect(e, props)
          }}
          onBlur={onBlur}
          {...props}
        />
        <span className='radio-checkmark'></span>
      </label>
    </div>
  );
};

export default RadioButton;
